import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const publicApi = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

export const organizationService = {
  getMine: async () => {
    const response = await api.get('/organizations/me');
    return response.data;
  },
  listMembers: async () => {
    const response = await api.get('/organizations/me/members');
    return response.data;
  },
  listInvites: async () => {
    const response = await api.get('/organizations/me/invites');
    return response.data;
  },
  createInvite: async (data) => {
    const response = await api.post('/organizations/me/invites', data);
    return response.data;
  },
  revokeInvite: async (id) => {
    const response = await api.patch(`/organizations/me/invites/${id}/revoke`);
    return response.data;
  },
  updateRetention: async (data) => {
    const response = await api.patch('/organizations/me/retention', data);
    return response.data;
  },
  previewInvite: async (token) => {
    const response = await publicApi.get(`/organizations/invites/${token}`);
    return response.data;
  },
  acceptInvite: async (token, data) => {
    const response = await publicApi.post(`/organizations/invites/${token}/accept`, data);
    return response.data;
  },
};

export default organizationService;
